import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Users, ShieldCheck, CreditCard, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full bg-navy-900 text-white overflow-hidden pt-8 pb-12 lg:pt-16 lg:pb-24" data-id="element-143">
      <div className="absolute inset-0 bg-court-pattern opacity-50" data-id="element-144"></div>

      {/* Decorative baseline */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-optic" data-id="element-145"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center space-y-5 lg:space-y-6" data-id="element-147">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-3 py-1 w-fit" data-id="element-148">
            <span className="w-2 h-2 rounded-full bg-optic animate-pulse" data-id="element-149"></span>
            <span className="text-[10px] sm:text-xs font-semibold tracking-wider uppercase text-cream" data-id="element-150">
              Megapack Tenis Resuelto
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display leading-[0.9] text-white" data-id="element-151">
            Todo tu año de{' '}
            <span className="text-optic block mt-1 lg:mt-2" data-id="element-152">
              tenis resuelto.
            </span>
          </h1>

          {/* Product mockup at 70% — positioned between title and subtitle */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          rotate: 2
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative w-full max-w-[245px] sm:max-w-[315px] lg:max-w-[420px] mx-auto py-2" data-id="element-153">
            <div className="absolute inset-0 bg-optic/20 blur-[100px] rounded-full" data-id="element-154"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ssc1mCTJK24HVYGCFJgYuk/heylloyd-image-1778112561105-Photoroom.png" alt="Megapack Tenis Resuelto - libros y recursos" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-155" />
          </motion.div>

          <p className="sm:text-lg lg:text-xl text-gray-300 font-medium max-w-xl text-[14px]" data-id="element-156">
            6 Tomos · 60+ Recursos · 6 Bonos · Listo para usar.
          </p>

          <p className="text-sm sm:text-base lg:text-lg text-gray-400 max-w-xl leading-relaxed" data-id="element-157">
            Tu año completo de clases de tenis listo: técnica, táctica, físico,
            planificación, mentalidad y negocio.{' '}
            <strong className="text-white" data-id="element-158">Sin improvisar.</strong>
          </p>

          <div className="flex flex-wrap justify-center gap-2 pt-1" data-id="element-159">
            <div className="flex items-center gap-1.5 bg-navy-800 px-2.5 py-1 rounded-md text-xs sm:text-sm font-medium text-gray-300 border border-white/5" data-id="element-160">
              <FileText className="w-3.5 h-3.5 text-terracotta" data-id="element-161" /> PDF Digital
            </div>
            <div className="flex items-center gap-1.5 bg-navy-800 px-2.5 py-1 rounded-md text-xs sm:text-sm font-medium text-gray-300 border border-white/5" data-id="element-162">
              <Zap className="w-3.5 h-3.5 text-optic" data-id="element-163" /> Acceso Inmediato
            </div>
            <div className="flex items-center gap-1.5 bg-navy-800 px-2.5 py-1 rounded-md text-xs sm:text-sm font-medium text-gray-300 border border-white/5" data-id="element-164">
              <Users className="w-3.5 h-3.5 text-blue-400" data-id="element-165" /> Todos los niveles
            </div>
          </div>

          <div className="pt-2 lg:pt-4 w-full sm:w-auto" data-id="element-166">
            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="group relative inline-flex items-center justify-center gap-2 bg-optic text-navy-900 px-5 py-3 lg:px-8 lg:py-4 rounded-lg font-display text-base lg:text-xl uppercase tracking-wide hover:bg-white transition-all shadow-glow hover:shadow-glow-lg w-full sm:w-auto" data-id="element-167">
              💥 QUIERO MI TENIS RESUELTO AHORA
              <ArrowRight className="w-5 h-5 lg:w-6 lg:h-6 group-hover:translate-x-1 transition-transform" data-id="element-168" />
            </button>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-xs sm:text-sm text-gray-400 font-medium mt-1" data-id="element-169">
            <div className="flex items-center gap-1.5" data-id="element-170">
              <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-171" /> Garantía 7 días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-172">
              <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-173" /> Pago 100%
              seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-174">
              <CreditCard className="w-4 h-4 text-gray-400" data-id="element-175" /> Mercado Pago |
              Tarjeta
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}